import { Alert, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useToast } from '../store/toast';

export default function Toaster() {
  const { items, remove } = useToast();
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        maxWidth: '92vw',
      }}
    >
      {items.map((t) => (
        <Alert
          key={t.id}
          severity={t.severity}
          variant="filled"
          onClose={() => remove(t.id)}
          sx={{ boxShadow: 3, alignItems: 'center' }}
          action={
            <IconButton size="small" color="inherit" onClick={() => remove(t.id)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {t.message}
        </Alert>
      ))}
    </Box>
  );
}
